import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  static get<T>(key: string): T {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      console.log(error);
    }
  }

  static set(key: string, item: string): void {
    localStorage.setItem(key, item);
  }

  static remove(key: string): void {
    localStorage.removeItem(key);
  }
}
